import { render } from "./Agreement.vue?vue&type=template&id=022924b4&scoped=true"
import script from "./Agreement.vue?vue&type=script&setup=true&lang=js"
export * from "./Agreement.vue?vue&type=script&setup=true&lang=js"

import "./Agreement.vue?vue&type=style&index=0&id=022924b4&lang=scss&scoped=true"

import exportComponent from "/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-022924b4"],['__file',"src/modules/billing/components/Agreement.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "022924b4"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('022924b4', __exports__)) {
    console.log('reload')
    api.reload('022924b4', __exports__)
  }
  
  module.hot.accept("./Agreement.vue?vue&type=template&id=022924b4&scoped=true", () => {
    console.log('re-render')
    api.rerender('022924b4', render)
  })

}


export default __exports__